import React from "react";
import classNames from "classnames";
import { useDrag } from "react-dnd";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

import styles from "./AvailablePurchaseOrders.css";

export const DraggableType = "purchaseOrder";

const shouldDisable = (purchaseOrder, activeCrew) =>
  activeCrew &&
  purchaseOrder.office &&
  !activeCrew.offices.some((o) => o.id === purchaseOrder.office.id);

const PurchaseOrder = ({
  activeCrew,
  locationEnabled,
  purchaseOrder,
  onClick,
}) => {
  const disable = shouldDisable(purchaseOrder, activeCrew);
  const [, drag] = useDrag({
    item: {
      purchaseOrderId: purchaseOrder.id,
      purchaseOrder,
      type: DraggableType,
    },
  });
  return (
    <div
      className={classNames(styles.purchaseOrder, {
        [styles.disabled]: disable,
      })}
      onDoubleClick={disable ? null : onClick}
      ref={drag}
    >
      <div>
        <div>
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
              margin: 0,
            }}
          >
            <b>
              {purchaseOrder.poNumber} - {purchaseOrder.name}
            </b>
          </h5>
        </div>
        <div
          className={styles.purchaseOrderHeader}
          style={{ padding: "0px 8px 8px 8px" }}
        >
          {purchaseOrder.office && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Office
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {purchaseOrder.office.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {purchaseOrder.status && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Status
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {purchaseOrder.status.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {purchaseOrder.supplier && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Supplier
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {purchaseOrder.supplier.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {locationEnabled && purchaseOrder.shipTo && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Ship To
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {purchaseOrder.shipTo}
              </FormControl.Static>
            </FormGroup>
          )}
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrder;
